module.exports = __webpack_public_path__ + "static/media/spada-trader-banner.9f1f5dd6.jpg";